module.exports = __webpack_public_path__ + "img/L_315_0.70814e3a.png";